import styled from "styled-components";
import { colors } from "src/theme/colors";
import { line, space, text } from "src/theme/ui";

/**
 * One more true thing, on a card that has the room for it.
 *
 * Sits on the card's own floor — `margin-top: auto`, so it goes to the
 * bottom of the body whatever is above it — under a hairline, in the label
 * treatment the rest of the product uses for a caption. Quiet on purpose:
 * it is there because the card would otherwise end in paper, so it must
 * read as a footnote to the figure above and never as a second headline.
 *
 * It is rendered ONLY where there is spare room; see `useCardRoom`. A card
 * whose content fills it shows nothing at all.
 */
const CardNote = styled.div`
  display: flex;
  flex: none;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px ${space.md}px;
  width: 100%;
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px dotted ${colors.gray[200]};

  ${text.label}
  color: ${colors.gray[500]};

  b {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: ${colors.gray[800]};
  }
`;

export default CardNote;
